export const app = {
    releaseStage: process.env.REACT_APP_FRONT_BUILD_ENV,
    giftlyUrl: process.env.REACT_APP_GIFTLY_URL,
    giftlyChromeStoreLink: process.env.REACT_APP_GIFTLY_CHROME_STORE_LINK,
    giftlyFaq: process.env.REACT_APP_GIFTLY_FAQ_URL
};
